import DefaultLayout from '../Layouts/DefaultLayout';

import ContactList from '../Components/ContactList';

function App() {
    return (
        <DefaultLayout>
            <div className="pb-4 md:pb-6 2xl:pb-10">
                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    <div className="col-span-12">
                        <div className="relative z-[1] mb-10 md:mb-16 xl:mb-20 before:content-[''] before:absolute before:top-0 before:bottom-0 before:w-screen before:left-1/2 before:bg-quaternary before:-translate-x-1/2 before:-z-[1]">
                            <div className="flex flex-col py-5 md:py-10">
                                <h2 className="max-sm:text-2xl max-lg:text-4xl max-md:mt-2 lg:text-[44px] text-secondary font-semibold">
                                    Contatos
                                </h2>
                            </div>
                        </div>

                        <ContactList />
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
}

export default App;
